export default __webpack_public_path__ + "static/media/SH6.84121fa6.jpg";